import React, { useMemo } from 'react';
import app from '@frontastic/catwalk/src/js/app/app';

const DEFAULT_STEP = 32;

export const useHiddenPaginationLinks = (node, route, tastic, urlHandler, stream, context) => {
  const itemsLimit = context?.project?.configuration?.category?.limit ?? DEFAULT_STEP;

  const hiddenPaginateLinks = useMemo(() => {
    const r = app.getRouter();
    const links = [];
    const nodeId = node.nodeType === 'search' ? route.route : `node_${node.nodeId}`;
    for (let i = 0; i * itemsLimit < stream.total; i++) {
      const params = urlHandler.deriveParameters((urlState) => {
        const stream = urlState.getStream(tastic.configuration.stream.dataSourceId);
        stream.setOffset(itemsLimit * i);
        stream.setLimit(itemsLimit);
      });

      const linkTitle = `Page ${i + 1}`;
      try {
        const mayBeLink = () => {
          if (r.path(nodeId, params)) {
            return r.path(nodeId, params);
          }
          return false;
        };

        if (mayBeLink()) {
          links.push(
            <a title={linkTitle} href={r.path(nodeId, params)}>
              {linkTitle}
            </a>,
          );
        }
      } catch (error) {
        return false;
      }
    }

    return (
      <ul style={{ display: 'none' }} aria-hidden={true} tabIndex={-1}>
        {links.map((link, i) => (
          <li key={i}>{link}</li>
        ))}
      </ul>
    );
  }, [itemsLimit, stream.total]);

  return {
    hiddenPaginateLinks,
  };
};
